import React, {useState} from 'react';
import styled from "styled-components";
import {numberFormat} from "../../../../libs/util";
import {OsIcon} from "../../../../common/icons";

const OsListComponent_=({data, osType, addEstimateItem})=>{
    const [onMouse, setOnMouse]=useState(false)
    const onMouseHandler=(flag)=>{
        setOnMouse(flag)
    }
    return (
        <>
            <OsItem className={`os-buy-body-box-ul-li-${osType}`}>
                <h5 className={`tit-h5 ${osType}-icon`}>
                    {osType==='pro'
                        ?(
                            <>기업이 회사<span>에서 사용하는 경우</span></>
                        ):(
                            <>개인이 집<span>에서 사용하시는 경우</span></>
                        )
                    }
                </h5>

                <div className="os-product">
                    <strong className="os-product-name">{data.itemFullName}</strong>
                    <div className="os-product-est">
                        <OsItemInfo>
                            <OsItemText>최저</OsItemText>
                            <OsItemPrice>{numberFormat(data.price)}</OsItemPrice>
                            <OsItemPriceUnit>원</OsItemPriceUnit>
                            <OsItemButton
                                onClick={() => addEstimateItem(data.itemId)}
                                onMouseEnter={() => onMouseHandler(true)}
                                onMouseLeave={() => onMouseHandler(false)}
                            >
                                <OsIcon size='15'/>
                                {onMouse && (
                                    <div className={`label-box`}>
                                        {data.hasStock
                                            ? (
                                                <StockLabel>재고인증</StockLabel>
                                            ) : (
                                                <span style={{width:'58px'}}></span>
                                            )
                                        }
                                        <span className={'os-plus'}>
                                            <OsIcon size='15'/>
                                            상품견적담기
                                        </span>
                                    </div>
                                )}
                            </OsItemButton>
                        </OsItemInfo>
                    </div>
                </div>
            </OsItem>
        </>
    )
}

export default OsListComponent_

const OsItem=styled.li``


const OsItemInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
`
const OsItemText = styled.div`
    font-size: 14px;
    color: #999999;
    line-height: 19px;
    margin-right: 3px;
`
const OsItemPrice = styled.div`
    font-size: 32px;
    color: #F34522;
    line-height: 32px;
    text-align: center;
    font-weight: bold;
`
const OsItemPriceUnit = styled.div`
    font-size: 14px;
    color: #999999;
    line-height: 19px;
    margin-left: 2px;
    margin-right: 2px;
`
const OsItemButton = styled.div`
    width:27px;
    height:27px;
    position:relative;
    color:#fff;
    background:#418ded;
    cursor:pointer;
    box-sizing:border-box;
    &>i{
        position:absolute;
        top:50%;left:50%;
        transform:translate(-50%,-50%);
    }
    .label-box{
        position:absolute;
        top:0;left:-165px;
        display:flex;
        align-items: center;
        .os-plus{
            border:1px solid #418ded;
            display:inline-block;
            font-size:16px;
            line-height: 25px;
            background:#418ded;
            text-align: center;
            padding:0 8px;
            i{
                margin-right:8px;
            }
        }
    }
`
const StockLabel = styled.div`
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 58px;
    border: 1px solid #418DED;
    color: #418DED;
    font-size: 12px;
    background-color: #fff;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceAsseblyLayer/osListComponent.js